// TODO: Casing is inconsistent, we should probably fix that
type FreePlanId = 'free_legacy' | 'free_v1' | 'free_migrated'

// This is a temporary convenience composable to help us determine what features
// the current user should be allowed to see, for both legacy and new users

export default function useUserPlanInfo() {
  const businessStore = useBusinessStore()
  const userStore = useUserStore()

  const businessPlanId = computed(() => businessStore.pricePlan.current.base?.type)
  const currentPaymentStatus = computed(() => businessStore.billing.paymentStatus)

  const activePricePlanId = computed<PricePlanId | FreePlanId | null>(() => {
    if (businessPlanId.value && businessPlanId.value !== 'CANCELED') {
      return businessPlanId.value
    }

    const freePlanId = userStore.attributes.freeAccountType as FreePlanId | undefined
    if (freePlanId) {
      return freePlanId
    }

    return null
  })

  const isFreePlan = computed(() => {
    // FIXME: Currently, we cannot rely on the backend to consistently handle the `free_account_type` attribute
    return !businessPlanId.value && !userStore.isBusinessMember // && Boolean(activePricePlanId.value?.toLowerCase().startsWith('free_'))
  })

  const isNewFreePlan = computed(() => {
    // FIXME: Currently, we cannot rely on the backend to consistently handle the `free_account_type` attribute
    return (
      !businessPlanId.value && (activePricePlanId.value === 'free_v1' || activePricePlanId.value === 'free_migrated')
    )
  })

  const isIndividualPlan = computed(() => activePricePlanId.value?.startsWith('INDIVIDUAL'))
  const isProPlan = computed(() => activePricePlanId.value === 'PRO_V1')
  const isScalePlan = computed(() => activePricePlanId.value === 'SCALE')
  const isTrialPlan = computed(() => activePricePlanId.value?.startsWith('TRIAL'))
  const isStarterPlan = computed(() => activePricePlanId.value === 'STARTER')

  const planStart = computed(() => {
    return businessStore.pricePlan.current.base?.startAt
  })

  const shouldAddPaymentMethod = computed(() => {
    return isStarterPlan.value && currentPaymentStatus.value === 'NOT_SET'
  })

  const shouldUpdatePaymentMethod = computed(() => {
    return isStarterPlan.value && currentPaymentStatus.value === 'UPDATE_REQUIRED'
  })

  const hasBillingAddress = computed(() => {
    if (!businessStore.billing) return false
    const { address1, city, postalCode, country } = businessStore.billing
    return Boolean(address1 && city && postalCode && country)
  })

  return {
    activePricePlanId,
    isFreePlan,
    isNewFreePlan,
    isIndividualPlan,
    isProPlan,
    isScalePlan,
    isTrialPlan,
    planStart,
    isStarterPlan,
    shouldAddPaymentMethod,
    shouldUpdatePaymentMethod,
    hasBillingAddress,
  }
}
